<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-文章-编辑
    -->
  <div class="product-add pb50" v-loading="loading">
    <!--编辑文章-->
     <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
       <div class="common-form">编辑文章</div>
       <el-form-item label="赠送人名称" prop="user"><el-input v-model="form.user" placeholder="请输入赠送人名称" class="max-w460"></el-input></el-form-item>
       <el-form-item label="接受人名称" prop="owner"><el-input v-model="form.owner" placeholder="请输入接收人名称" class="max-w460"></el-input></el-form-item>
       <el-form-item label="商品名称" prop="product_name"><el-input v-model="form.product_name" placeholder="请输入商品名称" class="max-w460"></el-input></el-form-item>
       <el-form-item label="商品编号" prop="number"><el-input v-model="form.number" placeholder="请输入商品编号" class="max-w460"></el-input></el-form-item>
       <el-form-item label="商品编号" v-show="false" prop="user_id"><el-input v-model="form.user_id" placeholder="用户id" class="max-w460"></el-input></el-form-item>
<!--       <el-form-item label="文章缩略图">-->
<!--         <div>-->
<!--           <el-button type="primary" @click="openUpload">上传图片</el-button>-->
<!--           <img class="mt10" v-img-url="'image.file_path',form"  width="120px;" alt="" />-->
<!--           &lt;!&ndash;上传图片组件&ndash;&gt;-->
<!--           <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>-->
<!--         </div>-->
<!--       </el-form-item>-->
<!--       <el-form-item label="文章分类">-->
<!--         <el-select v-model="form.category_id" placeholder="请选择">-->
<!--           <el-option v-for="(item, index) in category" :key="index" :label="item.name" :value="item.category_id"></el-option>-->
<!--         </el-select>-->
<!--       </el-form-item>-->
<!--       <el-form-item label="虚拟阅读量"><el-input type="number" v-model="form.virtual_views" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>-->
<!--       <el-form-item label="文章状态">-->
<!--         <el-radio-group v-model="form.article_status">-->
<!--           <el-radio :label="1">显示</el-radio>-->
<!--           <el-radio :label="0">隐藏</el-radio>-->
<!--         </el-radio-group>-->
<!--       </el-form-item>-->
<!--       <el-form-item label="文章内容">-->
<!--         <div class="edit_container">-->
<!--           <Uediter v-if="!loading" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>-->
<!--         </div>-->
<!--       </el-form-item>-->
<!--       <el-form-item label="排序"><el-input type="number" v-model="form.article_sort" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>-->
<!--       &lt;!&ndash;提交&ndash;&gt;-->
<!--       <div class="common-button-wrapper">-->
         <el-button size="small" type="info" @click="cancelFunc" :loading="loading">取消</el-button>
         <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
<!--       </div>-->
     </el-form>
  </div>
</template>

<script>
import TansferApi from '@/api/transfer.js';
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*编辑器*/
    Uediter,
    /*图片上传*/
    Upload: Upload
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*是否上传图片*/
      isupload: false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        user: '',
        owner: '',
        product_name: '',
        number:'' ,
      },
      /*新闻类别*/
      category: [],
      /*验证规则*/
      rules: {
        user: [{ required: true, message: '请输入赠送人名称', trigger: 'blur' }],
        owner: [{ required: true, message: '请输入接收人名称', trigger: 'blur' }],
        product_name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        number: [{ required: true, message: '请输入商品编号', trigger: 'blur' }]
      }
    };
  },
  created() {

    this.getDetail();

  },

  methods: {

    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    // getContent: function() {
    //   return this.$refs.ue.getUEContent();
    // },

    /*获取图片*/
    // returnImgsFunc(e) {
    //   let self = this;
    //   if (e != null) {
    //     this.form.image_id = e[0].file_id;
    //     this.form.image.file_path = e[0].file_path;
    //   }
    //   this.isupload = false;
    // },

    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      const params = self.$route.query.transfer_id;
      TansferApi.toEditTransfer({transfer_id: params},true).then(res => {
          self.ueditor.text = res.data.model.article_content;
          self.form = res.data.model;
          if(!self.form.image){
            self.form.image={};
          }
          self.category = res.data.catgory;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*修改文章*/
    onSubmit() {
      let self = this;
      let params = this.form;
      // self.form.article_content = this.$refs.ue.getUEContent();
      // 取到路由带过来的参数
      TansferApi.editArticle(params, true)
        .then(data => {
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.$router.push('/plus/article2');
        })
        .catch(error => {});
    },

    /*取消添加，返回文章列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/article2'
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/article2/article/edit.vue